/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

setTimeout(function() { 
        jQuery('.shopify-payment-button .shopify-payment-button__button--unbranded').text('CHECKOUT');
}, 2500);

